import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export default function Footer() {
  return (
    <Paper
      elevation={5}
      sx={{
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        align="center"
        sx={{
          my: "10px",
        }}
      >
        © 2025 3Nity. All Rights Reserved.
      </Typography>
    </Paper>
  );
}
